import React from "react";

const holder = {
  closeFiltersDropdown(e) {
    if (holder.containerRef && !holder.containerRef.current?.contains(e.target)) {
      holder.internalStateSetter('isOpen', false);
      document.removeEventListener("mousedown", holder.closeFiltersDropdown)
    }
  }
};

export default {
  'MultipleTagsPopup.BodyWrapper.Wrapper.BodyWrapper.ListWrapper.RemoveTags': ({ tag }, outlet) => {
    outlet({ tag })
  },
  'MultipleTagsPopup.Header': async ({ isOpen, containerRef }, _, internalStateSetter) => {
    let newContainerRef = containerRef;

    if (!containerRef) {
      newContainerRef = React.createRef(null);
      await internalStateSetter({ containerRef: newContainerRef });
    }

    await internalStateSetter({ isOpen: !isOpen });
    holder.internalStateSetter = internalStateSetter;
    holder.containerRef = newContainerRef;

    if (!isOpen) {
      document.addEventListener("mousedown", holder.closeFiltersDropdown);
    } else {
      document.removeEventListener("mousedown", holder.closeFiltersDropdown)
    }
  }
};
